import { DtBoolean } from '@ow/ditto-core'

const { transformer, filterSpec } = DtBoolean
export { transformer, filterSpec }
